export default {
  SET_FAMILY_LIST (state, list) {
    state.list = list
    state.lastUpdate = new Date()
  }
}
